// @ts-check
import { useAppConfigStore } from '@/js/stores/appConfig';
import { useSideNavbar } from './useSideNavbar';

export function useSideNavbarAccess() {
  const { sideNavbarRefs } = useSideNavbar();

  /**
   * Determines if an item should be visible.
   * @param {import('@/composables/useSideNavbar').SideNavbarItem} item - The item to check.
   */
  function isItemVisible(item) {
    const typedKey = /** @type {import('./useSideNavbar').SideNavbarItemSettingKeyConfigurable} */ (item.key);
    return sideNavbarRefs[typedKey]?.value ?? true;
  }

  /**
   * Checks if the user has access to the item.
   * @param {import('@/composables/useSideNavbar').SideNavbarItem} item - The item to check.
   * @returns {boolean} - Whether the user has access to the item.
   */
  function isItemAccessible(item) {
    if (item.skipAccesibilityCheck) {
      return true;
    }

    const appConfig = useAppConfigStore();

    return item.processId !== undefined
      && appConfig.availableProcessIds.includes(item.processId);
  }

  return {
    isItemVisible,
    isItemAccessible,
  };
}
